// extracted by mini-css-extract-plugin
module.exports = {"group":"_2rs5QVZ4ZuitZnx61ogwns","modalTitle":"_2BLptFNXsJWPRKXX2Ajfbm"};